import { Component, Input, OnInit } from '@angular/core';
import { Country } from '../../../shared/types/country.model';

@Component({
  selector: 'mmb-web-app-user-experience-heritage',
  templateUrl: './user-experience-heritage.component.html',
  styleUrls: ['./user-experience-heritage.component.scss']
})
export class UserExperienceHeritageComponent implements OnInit {
  @Input() countryExperiences: any[] = [{
    country: 'Austria',
    code: 'au',
    title: 'Remote professional'
  }, {
    country: 'Germany',
    code: 'gr',
    title: 'Lived'
  }, {
    country: 'Jamaica',
    code: 'jm',
    title: 'Lived'
  }];

  @Input() heritages: any[] = [{
    country: 'Jamaica',
    code: 'jm'
  }];

  constructor() { }

  ngOnInit() {
  }

}
